var map = {
	"./Bonito1BRAINFERG.xml": 355,
	"./Bonito21Mushroomhead.xml": 356,
	"./Bonito22SwagNewsletter.xml": 357,
	"./Bonito23AvantVibes.xml": 358,
	"./Bonito24Prada.xml": 359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354;